export default __webpack_public_path__ + "static/media/adsIcon.bda39be5.svg";